import { WebSocketContext } from '@/contexts/WebSocketContext';
import { CMDPsNbsBet } from '@/models/cmd/live';
import { CMDBet } from '@/models/cmd/live/CMDBet';
import { GameState } from '@/models/games/enums/GameState';
import { Bet, BetFormat } from '@/models/host/BetAmount';
import { getTableBetByHostId } from '@/modules/betTable/slice';
import { gameSliceActions } from '@/modules/games/slice';
import { getHostLiveDataByHostId } from '@/modules/hostLive/slice';
import { getLandingState, getMainUserState } from '@/modules/main/selector';
import { inGamePopupSliceActions } from '@/modules/popup/inGameSlice';
import { RootState } from '@/store/store';
import { isBitActive } from '@/utils/bitwiseUtil';
import { checkUnavailableBetsForABC } from '@/utils/commonFunc';
import {
    GLIDisableBetTypes as AndarBaharGLIDisableBetTypes,
    convertFResult as convertABFResult,
} from '@/utils/games/andarBahar';

import { MultiBetLiveContext } from '@/contexts/MultiBetLiveContext';
import { TableInfoContext } from '@/contexts/TableInfoContext';
import {
    BJ2BetBehind,
    BJ2CanRebet,
    BJ2MainBet,
    BJ2PairBet,
} from '@/models/games/blackjack2/enums/BetType';
import { GLIDisableBetTypes as BaccGLIDisableBetTypes } from '@/utils/games/baccarat';
import { GLIDisableBetTypes as DragonGLIDisableBetTypes } from '@/utils/games/dragonTiger';
import {
    GLIDisableBetTypes as FPCGLIDisableBetTypes,
    getFishPrawnCrabWinSet,
} from '@/utils/games/fishprawncrab';
import {
    convertPDFResultToDetail,
    getPokDengWinTypes,
} from '@/utils/games/pokdeng';
import {
    getSicBoWinSet,
    GLIDisableBetTypes as SicboGLIDisableBetTypes,
} from '@/utils/games/sicbo';
import {
    convertTPResult,
    GLIDisableBetTypes as TeenPatti2020GLIDisableBetTypes,
} from '@/utils/games/teenpatti';
import {
    getThaiHiLoWinSet,
    GLIDisableBetTypes as THLGLIDisableBetTypes,
} from '@/utils/games/thaiHiLo';
import {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { GameType as GameTypeEnum } from '../models/games/enums/GameType';
import { useIsBettingInfo } from './useIsBettingInfo';
import { useNBSBet } from './useNBSBet';
import { useNBSBetAction } from './useNBSBetAction';
import { useWinningAnim } from './useWinningAnim';
import { getBetSeats } from '@/modules/rwdGame/blackjack2/slice/seatSlice';
import { BetSeatIndex } from '@/models/games/blackjack2/SeatPlayerInfo';

const AUTO_BET_RESULT_TIMEOUT: number = 5000;
export const TABLE_BET_KEY = 'table_bet';

export type BalanceSummary = {
    serverBalance: number;
    serverHoldBalance: number;
    vaildBalance: number;
};
export type TableInfo = {
    hostId: number;
    gameId: number;
};
export const useTableBet = (hostId: number) => {
    const {
        balanceSummary,
        ConfirmedBets,
        isBetConfirmed,
        _doPendingBet,
        _doCancelBet,
        _doConfirmBet,
        _doUndoBet,
        getCurrentTotal,
        amountOverBetLimit,
        getHedgeBettingBets,
        isAutoConfirm,
        avaibleBalance,
        // isAutoConfirmEnabled,
    } = useNBSBet(hostId);

    const {
        setNoBetCount,
        selectedBetAmount,
        selectedBetRule,
        isMultiBet,
        currentPage,
        betTypesByPage,
        betSource,
        MaxBet,
        GameType,
        setIsBetting,
        setIsShuffling,
        setIsIdle,
    } = useContext(TableInfoContext);
    const [reBet, setRebet] = useState<boolean>(false);
    const [doubleBet, setDoubleBet] = useState<boolean>(false);
    const [winTypes, setWinTypes] = useState<Array<number>>([]);
    const [extraDisableBetTypes, setExtraDisableBetTypes] = useState<
        Array<number>
    >([]);
    const { sendCommand } = useContext(WebSocketContext);
    const { setMultibetPrevBets, getMultibetPrevBets } =
        useContext(MultiBetLiveContext);
    const [PrevBets, setPrevBets] = useState<Array<number>>();
    const dispatch = useDispatch();

    // const host = useSelector((state: RootState) => getHostById(state, hostId));
    const { ResultReleased, CurrentResult, CurrentState } = useSelector(
        (state: RootState) => getHostLiveDataByHostId(state, hostId)
    );

    const { IsDemo, blockLowRTP } = useSelector(getMainUserState);
    const [unavailableBetTypes, setUnavailableBetTypes] = useState<
        Array<number>
    >([]);
    const [displayBets, setDisplayBets] = useState<Array<number>>([]); //For ABC

    const { isSupportStorage } = useSelector((state: RootState) =>
        getLandingState(state)
    );
    const GLIDisableBetTypesList: Array<number> = useMemo(() => {
        if (!blockLowRTP) {
            return [];
        }
        switch (GameType) {
            case GameTypeEnum.AndarBahar:
                return AndarBaharGLIDisableBetTypes;
            case GameTypeEnum.Baccarat:
                return BaccGLIDisableBetTypes;
            case GameTypeEnum.Dragon:
                return DragonGLIDisableBetTypes;
            case GameTypeEnum.FishPrawnCrab:
                return FPCGLIDisableBetTypes;
            case GameTypeEnum.SicBo:
                return SicboGLIDisableBetTypes;
            case GameTypeEnum.TeenPatti2020:
                return TeenPatti2020GLIDisableBetTypes;
            case GameTypeEnum.ThaiHiLo:
                return THLGLIDisableBetTypes;
        }
        return [];
    }, [GameType]);
    useEffect(() => {
        return () => {
            setExtraDisableBetTypes([]);
        };
    }, [GameType]);
    const disableBetTypes = useMemo(
        () => GLIDisableBetTypesList.concat(extraDisableBetTypes),
        [extraDisableBetTypes, GLIDisableBetTypesList]
    );
    const {
        lastBetPage,
        setLastBetPage,
        _doPendingBets,
        _doPendingBetsWithAllin,
        betFailed,
    } = useNBSBetAction({
        hostId,
        amountOverBetLimit,
        getHedgeBettingBets,
        currentPage, // no need if 1 page
        betTypesByPage, // no need if 1 page
        disableBetTypes,
    });
    const {
        GameId,
        BetsSummary,
        PendingBets,
        TableTotalBet,
        PendingTotalBet,
        isWaitingBet,
        BetSeqId,
        PlayerBets,
        // minAmount,
    } = useSelector((state: RootState) => getTableBetByHostId(state, hostId));
    const { isBetting, isShuffling, IsRest, IsPause } = useIsBettingInfo(
        hostId,
        GameType
    );
    const seatInfos = useSelector((state: RootState) =>
        getBetSeats(state, hostId)
    );

    useEffect(() => {
        setIsIdle(CurrentState === GameState.Idle);
    }, [CurrentState]);
    useEffect(() => {
        // console.log('????', isBetting);
        setIsBetting(isBetting);
    }, [isBetting]);
    useEffect(() => {
        setIsShuffling(isShuffling);
    }, [isShuffling]);

    const timerRef = useRef<NodeJS.Timeout>();
    const {
        controller: winAnimationController,
        startAnim,
        stopAnim,
    } = useWinningAnim();

    const onAutoBetResultNotReceive = useCallback(() => {
        if (isAutoConfirm) {
            console.log('bet::abc::result::timeout::end');
            postMessage({ type: 3 });
        }
    }, [isAutoConfirm]);

    useEffect(() => {
        if (
            !IsRest &&
            CurrentState >= GameState.GameResult &&
            CurrentState < GameState.Shuffle &&
            CurrentResult?.GameID == GameId &&
            ResultReleased &&
            CurrentResult?.Result
        ) {
            switch (GameType) {
                case GameTypeEnum.Roulette:
                case GameTypeEnum.UltraRoulette:
                    break;
                case GameTypeEnum.SicBo:
                    if (CurrentResult.FResult) {
                        const winSet = getSicBoWinSet(
                            BigInt(CurrentResult.FResult)
                        );
                        setWinTypes(winSet);
                    }
                    break;
                case GameTypeEnum.PokDeng:
                    if (CurrentResult.FResult) {
                        const pdResult = convertPDFResultToDetail(
                            CurrentResult.FResult
                        );
                        setWinTypes(getPokDengWinTypes(pdResult));
                    }
                    break;
                case GameTypeEnum.AndarBahar:
                    if (CurrentResult.FResult) {
                        const abResult = convertABFResult(
                            BigInt(CurrentResult.FResult)
                        );
                        let arr = new Array<number>();
                        abResult.BetTypeWin.forEach((v, i) => {
                            if (v == true) {
                                arr.push(i);
                            }
                        });
                        setWinTypes(arr);
                    }
                    break;
                case GameTypeEnum.TeenPatti2020:
                    if (CurrentResult.FResult) {
                        const tpResult = convertTPResult(
                            BigInt(CurrentResult.FResult)
                        );
                        let arr = new Array<number>();
                        tpResult.BetTypeWin.forEach((v, i) => {
                            if (v == true) {
                                arr.push(i);
                            }
                        });
                        setWinTypes(arr);
                    }
                    break;
                case GameTypeEnum.ThaiHiLo:
                    if (CurrentResult.FResult) {
                        const winSet = getThaiHiLoWinSet(
                            BigInt(CurrentResult.FResult)
                        );
                        setWinTypes(winSet);
                    }
                    break;
                case GameTypeEnum.FishPrawnCrab:
                    if (CurrentResult.FResult) {
                        const winSet = getFishPrawnCrabWinSet(
                            BigInt(CurrentResult.FResult)
                        );
                        setWinTypes(winSet);
                    }
                    break;
                default:
                    if (CurrentResult.Result) {
                        let arr = new Array<number>();
                        for (let i = 0; i < 64; i++) {
                            if (isBitActive(CurrentResult.Result, i)) {
                                arr.push(i);
                            }
                        }
                        setWinTypes(arr);
                    }
                    break;
            }
        } else {
            setWinTypes([]);
        }
    }, [CurrentResult?.FResult, CurrentResult?.Result, CurrentState]);
    useEffect(() => {
        if (
            CurrentState >= GameState.GameResult &&
            CurrentState < GameState.Shuffle &&
            CurrentResult?.GameID == GameId &&
            ResultReleased &&
            CurrentResult?.Result
        ) {
            switch (GameType) {
                case GameTypeEnum.Roulette:
                case GameTypeEnum.UltraRoulette:
                    break;
                case GameTypeEnum.SicBo:
                    if (CurrentResult.FResult) {
                        const winSet = getSicBoWinSet(
                            BigInt(CurrentResult.FResult)
                        );
                        setWinTypes(winSet);
                    }
                    break;
                case GameTypeEnum.PokDeng:
                    if (CurrentResult.FResult) {
                        const pdResult = convertPDFResultToDetail(
                            CurrentResult.FResult
                        );
                        setWinTypes(getPokDengWinTypes(pdResult));
                    }
                    break;
                case GameTypeEnum.AndarBahar:
                    if (CurrentResult.FResult) {
                        const abResult = convertABFResult(
                            BigInt(CurrentResult.FResult)
                        );
                        let arr = new Array<number>();
                        abResult.BetTypeWin.forEach((v, i) => {
                            if (v == true) {
                                arr.push(i);
                            }
                        });
                        setWinTypes(arr);
                    }
                    break;
                case GameTypeEnum.TeenPatti2020:
                    if (CurrentResult.FResult) {
                        const tpResult = convertTPResult(
                            BigInt(CurrentResult.FResult)
                        );
                        let arr = new Array<number>();
                        tpResult.BetTypeWin.forEach((v, i) => {
                            if (v == true) {
                                arr.push(i);
                            }
                        });
                        setWinTypes(arr);
                    }
                    break;
                case GameTypeEnum.ThaiHiLo:
                    if (CurrentResult.FResult) {
                        const winSet = getThaiHiLoWinSet(
                            BigInt(CurrentResult.FResult)
                        );
                        setWinTypes(winSet);
                    }
                    break;
                case GameTypeEnum.FishPrawnCrab:
                    if (CurrentResult.FResult) {
                        const winSet = getFishPrawnCrabWinSet(
                            BigInt(CurrentResult.FResult)
                        );
                        setWinTypes(winSet);
                    }
                    break;
                default:
                    if (CurrentResult.Result) {
                        let arr = new Array<number>();
                        for (let i = 0; i < 64; i++) {
                            if (isBitActive(CurrentResult.Result, i)) {
                                arr.push(i);
                            }
                        }
                        setWinTypes(arr);
                    }
                    break;
            }
        } else {
            setWinTypes([]);
        }
    }, [CurrentResult?.FResult, CurrentResult?.Result, CurrentState, hostId]);

    useEffect(() => {
        if (winTypes.length > 0) {
            startAnim();
        } else {
            stopAnim();
        }
    }, [winTypes]);
    useEffect(() => {
        if (doubleBet) {
            let bets = new Array<Bet>();
            for (let i = 0; i < BetsSummary.length; i++) {
                if (BetsSummary[i]) {
                    let bet = {
                        GameId: GameId,
                        Type: i,
                        Amount: BetsSummary[i],
                    } as Bet;
                    bets.push(bet);
                }
            }
            for (let i = 0; i < ConfirmedBets.length; i++) {
                if (ConfirmedBets[i]) {
                    let bet = bets.find(v => v.Type == i);
                    if (bet) {
                        bet.Amount += ConfirmedBets[i];
                    } else {
                        bet = {
                            GameId: GameId,
                            Type: i,
                            Amount: ConfirmedBets[i],
                        } as Bet;
                        bets.push(bet);
                    }
                }
            }
            if (bets && bets.length > 0) {
                _doPendingBets(bets);
            }
            setDoubleBet(false);
            // dispatch(gameSliceActions.onDoubleBet({ onClick: false }));
        }
    }, [doubleBet]);
    useEffect(() => {
        if (reBet) {
            let bets = new Array<Bet>();
            if (isMultiBet) {
                const PrevBets_ = getMultibetPrevBets(hostId);
                if (PrevBets_) {
                    for (let i = 0; i < PrevBets_.length; i++) {
                        if (PrevBets_[i]) {
                            let bet = {
                                GameId: GameId,
                                Type: i,
                                Amount: PrevBets_[i],
                            } as Bet;
                            bets.push(bet);
                        }
                    }
                    if (bets && bets.length > 0) {
                        _doPendingBets(bets);
                    }
                }
            } else if (GameType == GameTypeEnum.Blackjack2 && PrevBets) {
                let mainBet: Array<number> = [];
                PrevBets.forEach((amount, index) => {
                    const seatIndex = `Seat${index % 10}` as BetSeatIndex;
                    let bj2ReBet = false;
                    if (
                        BJ2MainBet.indexOf(index) >= 0 &&
                        (seatInfos[seatIndex].IsMe ||
                            seatInfos[seatIndex].PlayerID == 0)
                    ) {
                        bj2ReBet = true;
                        mainBet.push(index % 10);
                    } else if (
                        BJ2PairBet.indexOf(index) >= 0 &&
                        (seatInfos[seatIndex].PlayerID > 0 ||
                            mainBet.indexOf(index % 10) >= 0)
                    ) {
                        bj2ReBet = true;
                    } else if (
                        BJ2BetBehind.indexOf(index) >= 0 &&
                        seatInfos[seatIndex].PlayerID > 0 &&
                        !seatInfos[seatIndex].IsMe
                    ) {
                        bj2ReBet = true;
                    }
                    if (bj2ReBet) {
                        let bet = {
                            GameId: GameId,
                            Type: index,
                            Amount: amount,
                        } as Bet;
                        bets.push(bet);
                    }
                });
                if (bets && bets.length > 0) {
                    _doPendingBets(bets);
                }
            } else if (PrevBets) {
                for (let i = 0; i < PrevBets.length; i++) {
                    if (PrevBets[i]) {
                        let bet = {
                            GameId: GameId,
                            Type: i,
                            Amount: PrevBets[i],
                        } as Bet;
                        bets.push(bet);
                    }
                }
                if (bets && bets.length > 0) {
                    _doPendingBets(bets);
                }
            }
            setRebet(false);
            // dispatch(gameSliceActions.onReBet({ onClick: false }));
        }
    }, [reBet]);
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = undefined;
            }
        };
    }, []);
    useEffect(() => {
        //ABC only
        if (isAutoConfirm) {
            if (isBetConfirmed) {
                setDisplayBets(ConfirmedBets);
            } else {
                if (unavailableBetTypes.length > 0) {
                    let tmp = PendingBets.concat();
                    unavailableBetTypes.forEach(v => {
                        tmp[v] = 0;
                    });
                    setDisplayBets(tmp);
                } else {
                    setDisplayBets(PendingBets);
                }
            }
        } else if (isAutoConfirm === false) {
            setDisplayBets(ConfirmedBets);
        }
    }, [ConfirmedBets, isBetConfirmed, PendingBets, isAutoConfirm]);
    useEffect(() => {
        //ABC only
        if (isBetConfirmed) {
            //reset after bet return
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = undefined;
                console.log('bet::abc::result::timeout::cancel');
            }
        }
    }, [isBetConfirmed]);
    useEffect(() => {
        if (ConfirmedBets && ConfirmedBets.length) {
            let prevBets = new Array<number>();
            if (GameType == GameTypeEnum.Blackjack2) {
                // let mySeat = [];
                // ConfirmedBets.forEach((amount, index) => {
                //     if (BJ2MainBet.indexOf(index) >= 0 && amount) {
                //         mySeat.push(index % 10);
                //     }
                //     if (
                //         BJ2CanRebet.indexOf(index) >= 0 &&
                //         mySeat.indexOf(index % 10) >= 0
                //     ) {
                //         prevBets[index] = amount;
                //     }
                // });
                if (seatInfos) {
                    ConfirmedBets.forEach((amount, index) => {
                        const seatIndex = `Seat${index % 10}` as BetSeatIndex;
                        if (
                            seatInfos[seatIndex] &&
                            seatInfos[seatIndex].PlayerID > 0
                        ) {
                            if (BJ2CanRebet.indexOf(index) >= 0)
                                prevBets[index] = amount;
                        }
                    });
                }
            } else {
                prevBets = ConfirmedBets.concat();
            }
            setPrevBets(prevBets);
            if (setMultibetPrevBets) setMultibetPrevBets(hostId, prevBets);
            setNoBetCount(0);
        }
    }, [ConfirmedBets]);
    useEffect(() => {
        setPrevBets([]);
    }, [GameType]);
    useEffect(() => {
        if (isAutoConfirm && GameType !== GameTypeEnum.Blackjack2) {
            //Blackjack 2 start game must be confirmed bet
            //ABC only
            if (!isBetting) {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                    timerRef.current = undefined;
                }
                if (TableTotalBet && !isBetConfirmed) {
                    console.log(
                        'bet::abc::result::timeout::start',
                        AUTO_BET_RESULT_TIMEOUT
                    );
                    //have bet
                    timerRef.current = setTimeout(() => {
                        onAutoBetResultNotReceive();
                    }, AUTO_BET_RESULT_TIMEOUT);
                }
            }
        }
    }, [isBetting]);
    useEffect(() => {
        if (isAutoConfirm && selectedBetRule && BetSeqId) {
            const cmd = new CMDPsNbsBet();
            cmd.gameID = GameId;
            cmd.BetSource = betSource;
            cmd.betFormat = BetFormat.AUTO_BET;
            cmd.betSeqID = BetSeqId;
            cmd.remark = balanceSummary
                ? `${balanceSummary.serverBalance},${balanceSummary.serverHoldBalance},${balanceSummary.vaildBalance}`
                : '';
            // let belowBetLimit = false;
            for (let i = 0; i < BetsSummary.length; i++) {
                if (BetsSummary[i]) {
                    let cmdBet = new CMDBet();
                    cmdBet.betType = i;
                    cmdBet.betAmount = BetsSummary[i];
                    // if (cmdBet.betAmount < selectedBetRule.MinBet) {
                    //     belowBetLimit = true;
                    // }
                    cmd.bets.push(cmdBet);
                }
            }

            if (isSupportStorage) {
                window.localStorage.setItem(
                    `${TABLE_BET_KEY}_${hostId}`,
                    `${BetSeqId};${GameId};${JSON.stringify(PlayerBets)}`
                );
            } else {
                window.sessionStorage.setItem(
                    `${TABLE_BET_KEY}_${hostId}`,
                    `${BetSeqId};${GameId};${JSON.stringify(PlayerBets)}`
                );
            }
            //not check, need send if undo
            // if (!belowBetLimit) {
            //     sendCommand(cmd);
            // }
            if (cmd.bets.length !== 0 || cmd.betSeqID > 1) {
                sendCommand(cmd);
            }
        }
    }, [BetSeqId]);

    useEffect(() => {
        stopAnim();
    }, [hostId]);

    useEffect(() => {
        if (isBetting && !IsDemo && !isMultiBet) {
            setNoBetCount(v => v + 1);
        }
    }, [isBetting]);

    useEffect(() => {
        if (isAutoConfirm && selectedBetRule && BetsSummary && MaxBet) {
            setUnavailableBetTypes(
                checkUnavailableBetsForABC({
                    gameType: GameType,
                    betsSummary: BetsSummary,
                    MaxBet: MaxBet,
                    MinBet: selectedBetRule.MinBet,
                })
            );
        }
    }, [BetsSummary, MaxBet, selectedBetRule]);

    const _doRouletteBet = (name: string | null) => {
        if (!selectedBetRule) {
            batch(() => {
                dispatch(
                    inGamePopupSliceActions.updateIsOpen({
                        hostId: hostId,
                        isOpen: true,
                    })
                );
                dispatch(gameSliceActions.onResetRoulSelectedTypes());
            });
            return;
        }
        const betTypeVal = name ? name.split('_')[0] : '';
        const containNumVal = name ? name.split('_')[1] : '';
        const betTypes =
            Number(betTypeVal) >= 1000
                ? containNumVal.split(',')
                : [Number(betTypeVal)];
        let bets = new Array<Bet>();
        betTypes.forEach(type => {
            let bet = bets.find(v => v.Type == type);
            if (bet) {
                bet.Amount += selectedBetAmount;
            } else {
                bet = {
                    GameId: GameId,
                    Type: type,
                    Amount: selectedBetAmount,
                } as Bet;
                bets.push(bet);
            }
        });
        if (bets && bets.length > 0) {
            if (bets.length === 1) {
                _doPendingBet(bets[0]);
            } else {
                _doPendingBetsWithAllin(bets);
            }
        }
    };

    return {
        _doPendingBet,
        _doRouletteBet, //For Roulette string input bets
        _doPendingBets, //For multi bet type, any bet type not available will cancel all bets
        _doCancelBet,
        _doConfirmBet,
        _doUndoBet,
        lastBetPage,
        setLastBetPage,
        GLIDisableBetTypesList,
        disableBetTypes,
        setExtraDisableBetTypes,
        PrevBets,
        displayBets,
        ConfirmedBets,
        PendingBets,
        BetsSummary,
        TableTotalBet,
        PendingTotalBet,
        isWaitingBet,
        unavailableBetTypes,
        setRebet,
        setDoubleBet,
        winTypes,
        winAnimationController,
        isBetting,
        isShuffling,
        CurrentResult,
        IsRest,
        getCurrentTotal,
        betFailed,
        avaibleBalance,
        IsPause,
        setPrevBets,
    };
};
export type useTableBetState = ReturnType<typeof useTableBet>;
